/* Book an Appointment widget - modal open/close, radio-driven store field
   toggle, and auto-reopen on the post-submit page reload (Shopify's native
   {% form 'contact' %} tag does a full reload; the modal isn't kept open by
   the browser, so re-open it here when the server rendered a
   posted_successfully/error state into the page). See
   snippets/book-appointment.liquid. */
(function () {
  function init(root) {
    var trigger = root.querySelector('[data-appt-trigger]');
    var overlay = root.querySelector('[data-appt-overlay]');
    var closeBtn = root.querySelector('[data-appt-close]');
    var form = root.querySelector('form');
    var radioBlocks = root.querySelectorAll('[data-radio]');
    var storeField = root.querySelector('[data-store-field]');
    var storeSelect = root.querySelector('[data-store-select]');
    var successEl = root.querySelector('[data-appt-success]');
    var errorEl = root.querySelector('[data-appt-error]');
    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      overlay.classList.add('is--active');
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var first = form ? form.querySelector('input:not([type="hidden"]):not([type="radio"]), select, textarea') : null;
      if (first) setTimeout(function () { try { first.focus(); } catch (e) {} }, 150);
    }

    function closeModal() {
      overlay.classList.remove('is--active');
      document.body.style.overflow = '';
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function updateRadios() {
      radioBlocks.forEach(function (block) {
        var input = block.querySelector('input[type="radio"]');
        block.classList.toggle('is--selected', !!(input && input.checked));
      });
      var selected = form ? form.querySelector('input[name="contact[appointment_type]"]:checked') : null;
      var inStore = !!(selected && selected.getAttribute('data-type') === 'instore');
      if (storeField) {
        storeField.classList.toggle('is--visible', inStore);
        if (storeSelect) {
          storeSelect.required = inStore;
          if (!inStore) storeSelect.value = '';
        }
      }
    }

    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) {
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is--active')) closeModal();
      });
    }

    radioBlocks.forEach(function (block) {
      var input = block.querySelector('input[type="radio"]');
      block.addEventListener('click', function () {
        if (input) { input.checked = true; updateRadios(); }
      });
      if (input) input.addEventListener('change', updateRadios);
    });

    updateRadios();

    if ((successEl && successEl.classList.contains('show')) || (errorEl && errorEl.classList.contains('show'))) {
      openModal();
    }
  }

  document.querySelectorAll('[data-book-appt]').forEach(init);
})();
